import h from 'hyperscript';

import { timeout } from '@disy/lib/timeout';
import { BUTTON_ICON_STYLE_CLASS, createButton } from '@disy/ui/button';

import type { Action } from 'cadenza/action';
import { theme } from 'cadenza/theming-api';

import './subnav.css';

class Subnav extends HTMLElement {
  _ready;
  _centerControls?: Element[];
  _spacer?: Element;

  constructor() {
    super();
    this._ready = timeout(); // when light DOM is ready
  }

  connectedCallback() {
    this.classList.add('is-resizable');
    this.classList.toggle('dark-bg', theme('view-header-invert'));

    this._ready.then(() => {
      if (this._centerControls) {
        this.append(...this._centerControls);
      }

      this.append((this._spacer = h('.d-spacer')));
    });
  }

  addAction(action: Action) {
    const button = createActionButton(action);
    button.hidden = true;
    this.addButton(button);
    return action.isSupported().then((supported) => {
      button.onclick = () => action.execute();
      button.hidden = !supported;
      return button;
    });
  }

  addButton(button: HTMLButtonElement, { atFirstPosition = false } = {}) {
    this._ready.then(() => this.insertBefore(button, atFirstPosition ? this.firstChild : this._spacer!.nextSibling));
  }
}

function createActionButton({ id, icon, label, styleClass }: Action) {
  const title = label as string;
  const button = createButton([icon, h('.visuallyhidden', title)], {
    title,
    styleClass,
    variant: 'borderless',
  });
  button.classList.add(BUTTON_ICON_STYLE_CLASS);
  if (id) {
    button.dataset.testid = id;
  }
  return button;
}

customElements.define('d-subnav', Subnav);
